<template>
  <div class="main-layout main-layout_fullpage main-layout_column" v-if="load">
    <!-- CALENDAR NAV BAR START -->
    <div class="calendar__nav">
      <!-- CALENDARS TABS START-->
      <tab-calendar :active="isActive" @changeView="changeView" />
      <!-- CALENDARS TABS END-->

      <!-- <div class="calendar__selects"> -->
      <!-- CHANGE CALENDAR MONTH START -->

      <Select2
        :options="months"
        class="calendar__select mr-12"
        v-model="currentMonth"
        @select="selectMonth($event)"
      />
      <!-- CHANGE CALENDAR MONTH END -->

      <!-- CHANGE CALENDAR YEAR START -->
      <Select2
        class="calendar__select mr-12"
        :options="years"
        v-model="year"
        @select="selectYear($event)"
        v-if="isActive !== 'week'"
      />
      <!-- CHANGE CALENDAR YEAR END -->

      <!-- CHANGE CALENDAR SERVICES START -->
      <Select2
        :options="services"
        :settings="selectSettingServices"
        class="calendar__select"
        @select="selectService($event)"
      />
      <!-- CHANGE CALENDAR SERVICES END -->
      <!-- </div> -->

      <Select2
        v-if="filteredList"
        :options="filteredList"
        :settings="{
            placeholder: $t('forms.default'),
            allowClear: false,
          }"
        v-model="office_id"
        class="select mr-12"
        @select="selectOffice"
      />
    </div>
    <!-- CALENDAR NAV BAR END -->

    <div class="calendar-stats" v-if="metrics !== null">
      <div>
        <el-tooltip
          class="calendar-stats__p calendar-stats__booked"
          :effect="isDark ? 'dark' : 'light'"
          content="Auslastung des Handwerkers mit Planaufträgen"
          placement="right"
        >
          <p>
            {{ $t("metrics.booked") }}
            <span
              :style="{
                color: getStatisticColors(metrics.indicator_1),
              }"
            >{{ round(metrics.indicator_1 )}}%</span>
          </p>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip
          class="calendar-stats__p calendar-stats__booked"
          :effect="isDark ? 'dark' : 'light'"
          content="Zeitdauer der Arbeit des Handwerkers im Schichtdienst (online)"
          placement="right"
        >
          <p>
            {{ $t("metrics.workload") }}
            <span
              :style="{
                color: getStatisticColors(metrics.indicator_2),
              }"
            >{{ round(metrics.indicator_2) }}%</span>
          </p>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip
          class="calendar-stats__p calendar-stats__booked"
          :effect="isDark ? 'dark' : 'light'"
          content="Aktuelle Zeitdauer des Handwerkers bei Kunden"
          placement="right"
        >
          <p>
            {{ $t("metrics.discipline") }}
            <span
              :style="{
                color: getStatisticColors(metrics.indicator_3),
              }"
            >{{ round(metrics.indicator_3) }}%</span>
          </p>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip
          class="calendar-stats__p calendar-stats__booked"
          :effect="isDark ? 'dark' : 'light'"
          content="Aktuelle Zeitdauer des Handwerkers bei Bestellungen online"
          placement="right"
        >
          <p>
            {{ $t("metrics.factual_workload") }}
            <span
              :style="{
                color: getStatisticColors(metrics.indicator_4),
              }"
            >{{ round(metrics.indicator_4) }}%</span>
          </p>
        </el-tooltip>
      </div>
    </div>

    <div class="calendar__wrapper">
      <!-- CALENDAR BREADCRUMBS START -->
      <div class="calendar__breadcrumbs" v-if="!breadcrumbsIsNull()">
        <breadcrumbs :breadcrumbs="breadcrumbsArray" />
      </div>
      <!-- CALENDAR BREADCRUMBS END -->

      <!-- CURRENT CALENDAR VIEW START -->
      <transition name="fade">
        <component
          :is="isActive"
          :month="month"
          :toDay="toDay"
          :detail="detail"
          :view="view"
          :monthDays="monthDays"
          :requestDetail="requestDetail"
          @getDetails="getDetails"
          @updateRequest="updateRequest"
          @deleteRequest="deleteRequest"
          @updateWeekCalendar="getWeek"
        />
      </transition>
      <!-- CURRENT CALENDAR VIEW END -->
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import breadcrumbs from '@/components/controls/breadcrumbs'

import CalendarMonth from '@/components/calendars/month/calendarMonth'
import CalendarDay from '@/components/calendars/day/calendarDay'
import CalendarWeek from '@/components/calendars/week/calendarWeek'

import getColor from '@/mixins/getStatisticColors'

import { firstDay, getNumberOfWeek, lastDay } from '@/utils/date'
import calendar from '@/plugins/calendar/calendar-js'
import moment from 'moment'

export default {
    beforeRouteLeave(to, from, next) {
        this.resetCalendar(next)
    },
    components: {
        mount: CalendarMonth,
        day: CalendarDay,
        week: CalendarWeek,
        breadcrumbs,
    },
    mixins: [getColor],
    data() {
        return {
            load: false,
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            view: this.$route.query.master ? 'employee' : 'default',
            searchValue: '',
            serviceid: '',
            breadcrumbsArray: null,
            years: [2022, 2021, 2020],
            year: new Date().getFullYear(),
            month: [],
            monthDays: [],
            currentMonth: new Date().getMonth(),
            currentYear: new Date().getFullYear(),
            currentDay: new Date().getDate(),
            toDay: '',
            currentMonthDates: {
                firstDay: null,
                lastDay: null,
            },
            startOfWeek: null,
            office_id: null,
        }
    },
    computed: {
        ...mapGetters({
            // store/modules/calendar
            monthRequests: 'monthRequestsGetters',
            requestDetail: 'requestDetailsGetters',
            isActive: 'isActiveGetters',
            executor: 'executorGetters',
            config: 'configGetters',
            months: 'monthsGetters',
            timeToUpdateCalendar: 'updateCalendarGetters',
            // store/modules/services
            services: 'servicesGettersWithAll',
            service: 'serviceGetters',
            dayGetters: 'dayGetters',
            metrics: 'metrics/currentMetrics',
            mView: 'metrics/view',
            activeTheme: 'activeTheme',
            filteredList: 'offices/filteredListAll',
        }),
        detail: {
            get() {
                return this.$store.state.calendar.detail
            },
            set(data) {
                this.$store.state.calendar.detail = data
            },
        },
        isDark() {
            return this.activeTheme === 'dark'
        },
    },
    watch: {
        async timeToUpdateCalendar(v) {
            if (!v) return

            await this.updateCalendar()
            this.setUpdateCalendar()
        },
        async $route() {
            await this.loadData()
        },
    },
    methods: {
        ...mapMutations({
            toggleUpdateInfo: 'requests/toggleUpdateInfo',
            setUpdateCalendar: 'setUpdateCalendar',
            setService: 'setService',
            setView: 'metrics/setState',
            setSnackbarShow: 'orders/setSnackbarShow',
        }),
        ...mapActions({
            fetchNewOrdersCount: 'orders/fetchNewOrdersCount',
            sendRequestInvoice: 'sendRequestInvoice',
        }),
        selectMonth({ id }) {
            this.changeMonth(parseInt(id))
        },
        selectYear(event) {
            this.currentYear = parseInt(event.text)
            this.year = parseInt(event.text)
            this.currentMonth = parseInt(this.currentMonth)

            const localFirstDay = Date.parse(
                new Date(this.currentYear, this.currentMonth, 1),
            )
            const ld = new Date(this.currentYear, this.currentMonth + 1, 0)
            const localLastDay = Date.parse(new Date(ld.setHours(23)))

            this.setCurrentDates({
                firstDay: localFirstDay,
                lastDay: localLastDay,
            })

            store
                .dispatch('getCalendarsData', {
                    firstDay,
                    lastDay,
                    service_id: this.serviceid,
                    office_id: this.office_id,
                })
                .then(() => {
                    this.view = 'default'
                    this.getMonth(this.currentYear, this.currentMonth)
                    this.month = calendar(this.config).detailed(
                        parseInt(this.currentYear),
                        parseInt(this.currentYear),
                    )
                })
        },
        selectOffice({ id }) {
            const period = this.getMonthPeriod()
            store
                .dispatch('getCalendarsData', {
                    firstDay: period.firstDay,
                    lastDay: period.lastDay,
                    office_id: id,
                    service_id: this.serviceid,
                })
                .then(() => {
                    this.view = 'services'
                    this.getMonth(this.currentYear, this.currentMonth)
                    this.$Progress.finish()
                })
        },
        async selectService({ id }) {
            const period = this.getMonthPeriod()
            this.$Progress.start()

            if (id === 'all') {
                store
                    .dispatch('getCalendarsData', {
                        firstDay: period.firstDay,
                        lastDay: period.lastDay,
                        office_id: this.office_id,
                    })
                    .then(() => {
                        this.view = 'default'
                        this.getMonth(this.currentYear, this.currentMonth)
                        this.$Progress.finish()
                    })

                this.setService('all')
            } else {
                this.setService(id)
                this.serviceid = id
                store
                    .dispatch('getCalendarsData', {
                        firstDay: period.firstDay,
                        lastDay: period.lastDay,
                        service_id: id,
                        office_id: this.office_id,
                    })
                    .then(() => {
                        this.view = 'services'
                        this.getMonth(this.currentYear, this.currentMonth)
                        this.$Progress.finish()
                    })
            }
        },
        changeView(view) {
            this.$store.state.calendar.showDetails = false
            store.state.calendar.isActive = view

            this.setView({
                key: 'view',
                value: view === 'day' ? 'day' : 'month',
            })
        },
        round(n) {
            return Math.round(n)
        },
        async search(value) {
            const period = this.getMonthPeriod()
            this.searchValue = value
            this.$Progress.start()

            await store.dispatch('getCalendarsData', {
                firstDay: period.firstDay,
                lastDay: period.lastDay,
                service_id: this.serviceid,
                employee: this.searchValue,
            })

            this.view = 'default'
            this.getMonth(this.currentYear, this.currentMonth)
            this.$Progress.finish()
        },
        updateRequest(id, data) {
            const period = this.getMonthPeriod()
            this.$Progress.start()
            store.dispatch('updateRequestDetails', { id, data }).then(() => {
                this.sendInvoice(id, data)

                store
                    .dispatch('getCalendarsData', {
                        firstDay: period.firstDay,
                        lastDay: period.lastDay,
                    })
                    .then(() => {
                        this.getMonth(this.currentYear, this.currentMonth)

                        this.fetchNewOrdersCount()
                        this.$Progress.finish()
                    })
            })
        },
        async sendInvoice(id, data) {
            if (data.paymnet_type !== undefined) {
                await this.sendRequestInvoice(id)
            }
        },
        deleteRequest(id) {
            const period = this.getMonthPeriod()
            this.$Progress.start()
            store.dispatch('deleteRequest', id).then(() => {
                store
                    .dispatch('getCalendarsData', {
                        firstDay: period.firstDay,
                        lastDay: period.lastDay,
                    })
                    .then(() => {
                        this.getMonth(this.currentYear, this.currentMonth)
                        this.$Progress.finish()
                    })
            })
        },
        resetCalendar(cb) {
            this.view = 'default'
            this.breadcrumbsArray = null
            cb()
        },
        breadcrumbsIsNull() {
            return this.breadcrumbsArray === null
        },
        setStartOfWeek(date) {
            this.startOfWeek = date
        },
        async getWeek() {
            await store.dispatch('getRequestWeekDetails', {
                date: this.startOfWeek,
                days: 14,
            })
        },
        async loadData() {
            const data = {
                firstDay,
                lastDay,
            }

            this.setCurrentDates({
                firstDay,
                lastDay,
            })
            if (this.$route.query.master) data.executor_id = this.$route.query.master

            await store.dispatch('getCalendarsData', data)

            this.setStartOfWeek(
                moment()
                    .day('Monday')
                    .add(1, 'day')
                    .format('YYYY-MM-DD'),
            )
            this.getWeek()

            if (this.$route.query.master !== undefined) {
                // if url contains master data
                await store
                    .dispatch('getMaster', {
                        id: this.$route.query.master,
                        type: 'masters',
                    })
                    .then(() => {
                        const master = store.getters.getMasterById
                        this.breadcrumbsArray = [
                            {
                                name: 'Masters',
                                link: '/admin/masters',
                            },
                            { name: `${master.first_name} ${master.last_name}` },
                        ]
                    })
            }

            this.toDay = new Date(
                this.currentYear,
                this.currentMonth,
                this.currentDay,
            )
            this.getMonth(this.currentYear, this.currentMonth)
            this.load = true
        },
        setCurrentDates({ firstDay: localFirstDay, lastDay: localLastDay }) {
            this.currentMonthDates.firstDay = localFirstDay
            this.currentMonthDates.lastDay = localLastDay
        },
        getMonth(year, month) {
            this.month = calendar(this.config).detailed(
                parseInt(year),
                parseInt(month),
            ) // get current calendar
            this.monthDays = []
            const calendars = this.month.calendar

            this.month.calendar = [] // clear month calendar
            this.month.numberOfWeek = []

            calendars.forEach((element) => {
                // foreach all week
                const newWeek = []
                element.forEach((item, i) => {
                    // foreach all days
                    element[i].index.weekDay = this.config.weekdays[i]
                    if (i === 0) {
                        this.month.numberOfWeek.push(
                            getNumberOfWeek(new Date(element[i].date)),
                        )
                    }

                    if (element[i].isInPrimaryMonth) {
                        // if month contain this day
                        if (this.$route.query.master) {
                            // if master has been chosen
                            element[i].requests = this.monthRequests[[item.day]]
                            item.requests = this.monthRequests[[item.day]]
                            item.executor = this.executor
                            this.monthDays.push(element[i])
                        } else {
                            element[i].requests = this.monthRequests[[item.day]]
                            item.requests = this.monthRequests[[item.day]]
                            this.monthDays.push(element[i])
                        }
                    } else {
                        if (this.$route.query.master) {
                            item.executor = this.executor
                        }
                        item.requests = ''
                    }

                    newWeek.push(item)
                })
                this.month.calendar.push(newWeek)
            })
        },
        changeMonth(monthAttr) {
            let month = monthAttr
            if (month < 0) {
                this.currentYear--
                month = 11
            } else if (month > 11) {
                this.currentYear++
                this.month = 0
            }

            let startOfWeek = moment()
                .set('month', month)
                .set('date', 1)
                .format('YYYY-MM-DD')

            if (this.toDay.getMonth() === month) {
                startOfWeek = moment()
                    .day('Monday')
                    .add(1, 'day')
                    .format('YYYY-MM-DD')
            }
            this.setStartOfWeek(startOfWeek)
            this.getWeek()

            const date = new Date(this.currentYear, month)
            const localFirstDay = Date.parse(
                new Date(date.getFullYear(), date.getMonth(), 1),
            )
            const ld = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            const localLastDay = Date.parse(new Date(ld.setHours(23)))

            this.$Progress.start()

            this.setCurrentDates({
                firstDay: localFirstDay,
                lastDay: localLastDay,
            })

            if (this.$route.query.master) {
                store
                    .dispatch('getCalendarsData', {
                        firstDay,
                        lastDay,
                        executor_id: this.$route.query.master,
                    })
                    .then(() => {
                        this.view = 'employee'
                        this.getMonth(this.currentYear, month)
                        this.$Progress.finish()
                    })
            } else {
                store
                    .dispatch('getCalendarsData', {
                        firstDay,
                        lastDay,
                        service_id: this.serviceid,
                        employee: this.searchValue,
                        office_id: this.office_id,
                    })
                    .then(() => {
                        this.getMonth(this.currentYear, month)
                        this.$Progress.finish()
                    })
            }
        },
        detailsDate(date) {
            this.detail = date
            this.changeView('day')
            const calendarBox = document.querySelector('.calendar')
            calendarBox.scrollTop = 0
        },
        getDetails(id, callback) {
            this.$Progress.start()
            store.dispatch('getRequestDetails', id).then(() => {
                this.$Progress.finish()
                callback()
            })
        },
        getMonthPeriod() {
            const date = new Date(this.currentYear, this.currentMonth)
            const localFirstDay = Date.parse(
                new Date(date.getFullYear(), date.getMonth(), 1),
            )
            const ld = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            const localLastDay = Date.parse(new Date(ld.setHours(23)))

            this.setCurrentDates({
                firstDay: localFirstDay,
                lastDay: localLastDay,
            })

            return {
                firstDay,
                lastDay,
            }
        },
        updateCalendarData() {
            this.$Progress.start()
            store
                .dispatch('getCalendarsData', {
                    firstDay,
                    lastDay,
                })
                .then(() => this.$Progress.finish())
            this.getMonth(this.currentYear, this.currentMonth)
        },
        async updateCalendar() {
            const data = {
                firstDay: this.currentMonthDates.firstDay,
                lastDay: this.currentMonthDates.lastDay,
            }

            await this.fetchCalendarsData(data)
            this.getMonth(this.currentYear, this.currentMonth)
        },
        async fetchCalendarsData(data) {
            await store.dispatch('getCalendarsData', data)
        },
    },
    async created() {
        this.setView({
            key: 'view',
            value: 'month',
        })
        await this.loadData()
        this.setSnackbarShow(false)
    },
    beforeDestroy() {
    // const navButton = document.querySelector('.js-calendar-upd');
    // navButton.removeEventListener('click', this.updateCalendarData);
        this.$store.state.calendar.isActive = 'mount'
        this.load = false
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.calendar {
  // padding: 36px 64px;
  width: 100%;
  height: 100%;
  box-sizing: border-box !important;
  // display: flex;
  // flex-direction: column;

  @include respond(desktop) {
    padding: 36px 55px !important;
  }

  &__breadcrumbs {
    margin-bottom: 12px;
  }

  &__box {
    height: calc(100vh - 64px);
    overflow-y: auto;
  }

  &__wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__nav {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-bottom: 27px;

    & .select {
      margin-left: 15px;
      margin-right: 15px;
      max-width: 240px;
      @include respond(desktop) {
        min-width: 190px !important;
        max-width: 190px;
      }
    }
  }

  &__selects {
    display: flex;
    margin-left: 40px;

    .calendar__select {
      margin-right: 100px;
    }
  }
}
</style>
<style lang="scss">
@import "src/assets/sass/main";

.calendar__select {
  & .select2-container {
    width: 240px;
    margin-left: 10px;
    margin-right: 10px;
    max-width: 240px;
    @include respond(desktop) {
      min-width: 190px !important;
      max-width: 190px;
    }
  }
}
</style>
